export default class Preloader {
    constructor() {
        this.container = document.querySelector("#preloader")
        this.loaded = false
        this.href = null
        
        // Esperar a que GSAP esté disponible (cargado con defer)
        if (gsap) {
            this.init();
        } else {
            // Si GSAP no está disponible aún, esperar al evento load
            window.addEventListener('load', () => this.init());
        }
    }

    init() {
        this.setTL()
        this.events()
    }

    events() {
        document.querySelectorAll(".change-page").forEach(item => {
            item.addEventListener("click", (e) => {
                const href = item.getAttribute("href")
                // Permitir comportamiento por defecto cuando se usan teclas modificadoras (Ctrl/Cmd/Shift/Alt)
                const isModifiedClick = e.ctrlKey || e.metaKey || e.shiftKey || e.altKey
                if (isModifiedClick) return
                if (href) {
                    e.preventDefault()
                    this.href = href
                    this.show()
                }
            })
        })
    }

    setTL() {
        if (!gsap) return;
        
        this.tl = gsap.timeline({
            paused: true
        }).to(this.container, {
            ease: 'power2.easeInOut',
            duration: .45,
            display: 'none',
            y: "-100%"
        }, 0).to("#logo-container", {
            ease: 'power2.easeInOut',
            duration: .45,
            y: "100%"
        }, 0).from("main", {
            ease: 'power2.easeInOut',
            duration: .45,
            y: 30
        }, 0.1)
    }

    show() {
        if (!this.loaded || !gsap) return false
        
        gsap.set(this.container, {
            display: 'flex',
            y: "100%"
        })
        gsap.set("#logo-container", {
            y: "-100%"
        })
        this.tl = gsap.timeline({
            paused: true,
            onComplete: () => {
                if (this.href) {
                    window.location.href = this.href
                }
            }
        }).to(this.container, {
            ease: 'power2.easeInOut',
            duration: .45,
            opacity: 1,
            y: "0%"
        }, 0).to("#logo-container", {
            ease: 'power2.easeInOut',
            duration: .45,
            y: "0%"
        }, 0).to("main", {
            ease: 'power2.easeInOut',
            duration: .45,
            opacity: 0,
            y: -30
        }, 0)
        return this.tl.duration(0.35).play()
    }

    hide() {
        if (this.loaded) return false
        this.loaded = true
        return this.tl.delay(3).play()
    }
}